import { jsx as s } from "react/jsx-runtime";
import { tv as b } from "tailwind-variants";
const m = b({
  base: [
    "border-b",
    "border-neutral-200",
    "flex",
    "gap-3",
    "items-center",
    "last:border-b-0",
    "mx-5",
    "*:py-4",
    "*:w-full",
    "tablet:m-0",
    "tablet:min-w-max",
    "tablet:*:px-4",
    "tablet:*:py-3"
  ],
  variants: {
    isSecondary: {
      true: ["*:pl-6", "tablet:*:pl-5"]
    },
    mobileOnly: {
      true: ["tablet:hidden"]
    }
  }
}), n = ({
  className: t,
  children: e,
  isSecondary: a,
  mobileOnly: l,
  tagName: r = "li"
}) => /* @__PURE__ */ s(r, { className: m({ class: t, isSecondary: a, mobileOnly: l }), children: e });
export {
  n as default
};
